import { z } from "zod";

import { auditDate } from "@/schemas";

export const moveInMoveOutSchema = z.object({
  auditDate: auditDate,
  locationId: z.string().min(1, "Required"),
  tenantName: z.string().min(1, "Required"),
  unit: z.string().min(1, "Required"),
  formType: z.union([z.literal("Move In"), z.literal("Move Out")]),
});
